export default __webpack_public_path__ + "static/media/attention.7eaae9fe.svg";